(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initSideBarMenu' in element.dataset) {
        return;
      }
      element.dataset.initSideBarMenu = true;

      const menuItemsLvl0 = element.querySelectorAll('.menu-item.lvl-0');
      if (menuItemsLvl0.length > 1) {
        element.classList.remove('lvl-0');
        element.classList.add('lvl-1');
        const lvls = element.querySelectorAll('.lvl-0');
        lvls.forEach((lvl) => {
          lvl.classList.remove('lvl-0');
          lvl.classList.add('lvl-1');
        });
      }
    });
  }

  Drupal.behaviors.sideBarMenu = {
    attach: () => {
      const elements = document.querySelectorAll('.js-side-bar-menu');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
